import React from 'react';

import {Heading} from '@albert-io/atomic';
import type {QueryBuilder} from '@albert-io/json-api-framework/request/builder';
import sessionStore from 'client/Session/SessionStore';
import {getBaseUserQuery} from 'client/User/UserQueryUtil';
import useAreLatestQueriesReady from 'lib/hooks/useAreLatestQueriesReady';

import {TeacherDashboardLayout} from './Layout/TeacherDashboardLayout';

const getGreeting = () => {
  const hour = new Date().getHours();
  if (hour < 12) {
    return 'Good Morning';
  }
  if (hour < 17) {
    return 'Good Afternoon';
  }
  return 'Good Evening';
};

interface Props {
  location?: {
    pathname: string;
  };
}

export const TeacherHomepage = ({location}: Props) => {
  const pathname = location?.pathname ?? '/home';

  const {isReady} = useAreLatestQueriesReady([
    () => getBaseUserQuery(sessionStore.getUserId()) as unknown as QueryBuilder
  ]);
  const firstName = isReady
    ? getBaseUserQuery(sessionStore.getUserId()).getResource().getFirstName()
    : '';

  return (
    <TeacherDashboardLayout pathname={pathname}>
      {/* 32px has no heading token (l=28, xl=34); the design specifies 3xl/32. */}
      <Heading as='h1' className='m-x0 text-[32px]! leading-[1.5]!' color='primary'>
        {getGreeting()}
        {firstName ? `, ${firstName}` : ''}
      </Heading>
    </TeacherDashboardLayout>
  );
};
